<h1 mat-dialog-title>Suppression</h1>
<div mat-dialog-content>
	<p>{{ question }}</p>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="false">Non</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Oui</button>
</div>
